<template>
    <div>
        <div
            class="absolute pin-b pin-r mr-md bg-accent-clay-orange-dark btn-circle text-white hover:bg-accent-clay-orange-dark-darker cursor-pointer z-20"
            :class="{ 'hidden': visible }"
            style="margin-bottom: 120px"
            @click="visible = ! visible"
        >
            <font-awesome-icon icon="list" />
        </div>
        <div v-if="visible" class="h-full z-10 fixed pin-r bg-white w-1/3 ml-auto field-list-group">
            <div>
                <div class="bg-neutral-darkest p-lg">
                    <select-input
                        v-model="selectedStatus"
                        :options="filterableStatuses"
                        :opt-out-sorting="true"
                        class="mb-0"
                    />
                </div>
                <div>
                    <div
                        v-for="community in filteredCommunities"
                        class="border-l-sm border-success pl-xl py-lg cursor-pointer"
                        :class="`border-${community.status_color}`"
                        @click="select(community)"
                    >
                        <span class="headline-sm font-semibold">
                            {{ community.name }}
                        </span>

                        <div class="flex">
                            <span class="text-xs mt-sm">
                                <span>
                                    <font-awesome-icon :icon="community.status_icon" :class="iconClass(community)" />
                                </span>
                                {{ community.status_label }}
                            </span>

                            <span v-if="community.information.number_of_households" class="text-xs mt-sm ml-md">
                                <span>
                                    <font-awesome-icon icon="home" />
                                </span>

                                {{ community.information.number_of_households }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 235px;" />
            <div class="fixed pin-b p-lg flex justify-center w-1/3 field-list-group-action">
                <button
                    type="button"
                    class="btn btn-md is-ghost"
                    @click="close"
                >
                    Stäng
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import merge from 'lodash-es/merge';
    import mapValues from 'lodash-es/mapValues';

    export default {
        props: {
            communities: {
                type: Array,
                default: null,
            },
            statuses: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                visible: false,
                selectedStatus: 'all',
            };
        },
        computed: {
            filterableStatuses() {
                const defaultStatus = {
                    all: 'Alla statusar',
                };

                const statusesInOptionsFormat = mapValues(
                    this.statuses,
                    (status) => {
                        return status.label;
                    },
                );

                return merge(defaultStatus, statusesInOptionsFormat);
            },
            filteredCommunities() {
                if (this.selectedStatus === 'all') {
                    return this.communities;
                }

                return this.communities.filter((community) => {
                    return community.status === this.selectedStatus;
                });
            },
        },
        methods: {
            close() {
                this.visible = false;
            },
            select(community) {
                EventBus.$emit('zoom-to-shape', 'c' + community.id);
                EventBus.$emit('clicked-community', community.id);
            },
            iconClass(community) {
                return `text-${community.status_color}`;
            },
        },
    };
</script>